import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface VoteRow {
  voter: string
  automatic: number
  engagement: number
  standardisation: number
  gender: number
  edited_by?: string | null
  edited_at?: string | null
}

export interface VoteOverride {
  voter: string
  standardisation: number
  engagement: number
}

@Component({
  selector: 'vote-breakdown',
  templateUrl: './vote-breakdown.component.html',
  styleUrls: ['./vote-breakdown.component.scss']
})
export class VoteBreakdownComponent {

  @Input() rows: VoteRow[] = []
  @Input() editable: boolean = false
  @Output() override: EventEmitter<VoteOverride> = new EventEmitter<VoteOverride>()

  editingVoter: string | null = null
  editStandardisation: number = 0
  editEngagement: number = 0

  truncateFloat(n: number): number {
    return Math.floor(n * 10) / 10
  }

  average(row: VoteRow): number {
    return this.truncateFloat(row.automatic * 0.3 + row.engagement * 0.3 + row.standardisation * 0.3 + row.gender * 0.1)
  }

  trackByVoter(_index: number, row: VoteRow): string {
    return row.voter
  }

  isEditing(row: VoteRow): boolean {
    return this.editingVoter === row.voter
  }

  startEdit(row: VoteRow): void {
    this.editingVoter = row.voter
    this.editStandardisation = row.standardisation
    this.editEngagement = row.engagement
  }

  cancelEdit(): void {
    this.editingVoter = null
  }

  saveEdit(row: VoteRow): void {
    if (this.editStandardisation == null || this.editEngagement == null ||
        this.editStandardisation < 0 || this.editStandardisation > 10 ||
        this.editEngagement < 0 || this.editEngagement > 10) {
      return
    }
    this.override.emit({
      voter: row.voter,
      standardisation: this.editStandardisation,
      engagement: this.editEngagement
    })
    this.editingVoter = null
  }

}
